import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const BioklimatikPergolaPage = () => {
  useEffect(() => {
    document.title = 'Bioklimatik Pergola Tente - İzmir Tente Tamir | Modern Pergola Sistemleri';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde bioklimatik pergola tente montajı ve tamiri. Akıllı havalandırma sistemli modern pergola çözümleri. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Otomatik Pergola Tente', link: '/hizmetler/otomatik-pergola-tente' },
    { title: 'Kasetli Tente', link: '/hizmetler/kasetli-tente' },
    { title: 'Zip Perde Tente', link: '/hizmetler/zip-perde-tente' },
    { title: 'Tente Tamiri', link: '/hizmetler/tente-tamiri' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <div className="pt-20 md:pt-24">
        <div className="w-full h-64 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/2935efca2eac55ee0347acfa7c7f5ea1.jpg"
            alt="Bioklimatik Pergola Tente"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6 mt-8">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Bioklimatik Pergola Tente</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Bioklimatik Pergola Tente
              </h1>
              
              <p className="text-base text-gray-700 mb-6 leading-relaxed">
                Bioklimatik pergola, modern mimari ve teknolojinin buluştuğu, akıllı havalandırma sistemine sahip yenilikçi bir gölgelendirme çözümüdür. Döner lamel sistemi sayesinde güneş ışığını ve hava akışını kontrol ederek dış mekanlarınızda ideal konfor sağlar. İzmir Tente Tamir olarak, bioklimatik pergola montajı ve tamir hizmetleri sunuyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Bioklimatik Pergola Nedir?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Bioklimatik pergola, döner alüminyum lamellerden oluşan ve bu lamellerin açısını ayarlayarak güneş ışığı, hava sirkülasyonu ve yağmur korumasını kontrol edebilen akıllı bir pergola sistemidir. Lameller tamamen açıldığında gökyüzünü görebilir, kapatıldığında ise tam su geçirmez bir çatı oluşturur.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Bioklimatik Pergola Özellikleri</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Döner Lamel Sistemi:</strong> 0-135 derece arasında ayarlanabilen alüminyum lameller</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Su Geçirmez:</strong> Lameller kapalıyken yağmura karşı tam koruma</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Havalandırma:</strong> Lameller açıldığında doğal hava sirkülasyonu</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Motorlu Kontrol:</strong> Uzaktan kumanda veya akıllı telefon ile kontrol</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Dayanıklı Yapı:</strong> Paslanmaz alüminyum ve çelik konstrüksiyon</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>LED Aydınatma:</strong> Entegre LED ışık sistemleri</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Sensör Desteği:</strong> Rüzgar, yağmur ve güneş sensörleri ile otomatik çalışma</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Bioklimatik Pergola Kullanım Alanları</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Bioklimatik pergolalar çeşitli alanlarda kullanılabilir:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Bahçe ve teras alanları</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Cafe ve restoran dış mekanları</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Otel ve tatil köyü havuz başları</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Villa ve rezidans bahçeleri</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Ticari işletme dış alanları</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Bioklimatik Pergola Avantajları</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Tam Kontrol:</strong> Güneş, hava ve yağmuru istediğiniz gibi kontrol edin</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Dört Mevsim Kullanım:</strong> Yaz ve kış aylarında konforlu kullanım</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Enerji Tasarrufu:</strong> Doğal havalandırma ile klima kullanımını azaltır</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Modern Tasarım:</strong> Estetik ve şık görünüm</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uzun Ömür:</strong> Dayanıklı malzemeler ile yıllarca kullanım</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Değer Artışı:</strong> Mülkünüzün değerini artırır</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Hizmetlerimiz</h2>
              
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Bioklimatik Pergola Montajı</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Profesyonel ekibimiz, alanınıza uygun bioklimatik pergola sistemini tasarlıyor ve monte ediyoruz. Ölçüm, proje ve montaj hizmetlerini eksiksiz sunuyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Bioklimatik Pergola Tamiri</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Mevcut bioklimatik pergola sisteminizdeki arızaları tespit edip tamir ediyoruz. Motor, lamel, sensör ve kontrol sistemleri tamiri yapıyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Bakım ve Servis</h3>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Düzenli bakım hizmetleri ile pergola sisteminizin uzun ömürlü olmasını sağlıyoruz. Yıllık bakım paketleri sunuyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Neden İzmir Tente Tamir?</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shr-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uzman Ekip:</strong> Bioklimatik pergola konusunda deneyimli teknisyenlerimiz var</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kaliteli Ürünler:</strong> Avrupa standartlarında pergola sistemleri</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Profesyonel Montaj:</strong> Hızlı ve özenli kurulum</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Garanti:</strong> Tüm işlemlerimiz garanti kapsamındadır</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-6 md:p-8 mt-8">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-sm md:text-base text-gray-700 mb-6">
                  Bioklimatik pergola montajı veya tamiri için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BioklimatikPergolaPage;